const POST_QUESTION = "POST_QUESTION"
const POST_QUESTION_SUCCESS = "POST_QUESTION_SUCCESS"
const POST_QUESTION_FAIL = "POST_QUESTION_FAIL"

const BASE_ENDPOINT = '/Sharepoint/Question';
const initialValues = {

  loading: false,
 hasError:false,
 questions:[],
};

const questions = (state = initialValues, action) => {

    switch (action.type) {
  
      case POST_QUESTION:{
  
        return{
           ...state,
           loading:true,
  
        }
  
      }
  
  
      case POST_QUESTION_SUCCESS:{
  
        return{
           ...state,
             loading:false,
        }
  
      }
    
      case POST_QUESTION_FAIL: {
        return {
          ...state,
          loading: false,
          hasError: true,
        };
      }


      default: {
        return state;
      }
  
    }
  };

export const postNewQuestion = (question) => {
    return {
      type: POST_QUESTION,
      payload: {
        request: {
            method:'POST',
          url: BASE_ENDPOINT,
          data:question  ,
          headers:{
              contentType:"multipart/form-data"
          }
        }
      }    
    }
};



export default questions;